<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 39.08 24.71"
    style="enable-background: new 0 0 39.08 24.71"
    xml:space="preserve"
    fill="currentColor"
    :class="{
      [`h-${height} w-${width}`]: true,
    }"
  >
    <g>
      <path
        class="text-gray-300"
        d="M37.06,8.7h-8.39V7.88c0-0.28-0.22-0.5-0.5-0.5h-4.84c-0.28,0-0.5,0.22-0.5,0.5V8.7H2.02
		C1.46,8.7,1,9.15,1,9.72v6.67c0,2.72,2.2,4.92,4.92,4.92h27.24c2.72,0,4.92-2.2,4.92-4.92V9.72C38.08,9.15,37.62,8.7,37.06,8.7z"
      />
    </g>
    <path
      class="text-gray-600"
      d="M37.06,7.7h-7.41c-0.09-0.74-0.72-1.32-1.48-1.32h-4.84c-0.76,0-1.39,0.58-1.48,1.32H4.82V3.35
	C4.82,2.61,5.43,2,6.18,2s1.35,0.61,1.35,1.35c0,0.55,0.45,1,1,1s1-0.45,1-1C9.53,1.5,8.03,0,6.18,0S2.82,1.5,2.82,3.35V7.7h-0.8
	C0.91,7.7,0,8.6,0,9.72v6.67c0,2.91,2.12,5.34,4.89,5.82v2.5h2v-2.4h24.92v2.4h2v-2.44c2.96-0.32,5.27-2.84,5.27-5.88V9.72
	C39.08,8.6,38.18,7.7,37.06,7.7z M23.84,8.38h3.84V14h-3.84V8.38z M37.08,16.39c0,2.16-1.76,3.92-3.92,3.92H5.92
	C3.76,20.31,2,18.55,2,16.39L2.02,9.7h19.81V16h7.84V9.7l7.41,0.02V16.39z"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
